import React from "react";
import "./product-head.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { formatDate } from "../../../../../../helpers";
import { useTranslation } from "react-i18next";
import { ProductStatus } from "../../../../../../modules/products/types/status";
import { ResponsablePersonComponent } from "../../../../../../components/responsable-person/responsable-person.component";

interface ProductHeadComponentProps {
  loading: boolean;
  product: any;
}

const ProductHeadComponent = ({
  loading,
  product,
}: ProductHeadComponentProps) => {
  const { t } = useTranslation();

  return (
    <Box className="product__head">
      <Box className="product__head__info global__box__content py-3">
        {loading ? (
          <Skeleton variant="text" height={20} width={350} className="mb-1" />
        ) : (
          <Typography variant="h1" className="mb-1 text-capitalize">
            {product?.name}
          </Typography>
        )}
        {loading ? (
          <Skeleton variant="text" height={20} width={250} />
        ) : (
          <Typography variant="h4">{product?.vendor}</Typography>
        )}
        {loading ? (
          <Skeleton variant="text" height={20} width={200} />
        ) : (
          <a
            href={product?.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: "14px", display: "block", fontWeight: 400 }}
          >
            {product?.link}
          </a>
        )}
        {loading ? (
          <Skeleton variant="text" height={20} width={200} className="my-2" />
        ) : (
          <Typography
            variant="caption"
            className="my-2 text-capitalize"
            style={{ display: "block" }}
          >
            {t("LAST_MODIFIED_BY")} {product?.modifiedBy?.name},{" "}
            {formatDate(product?.updatedAt, "DD.MM.YYYY HH:mm")}
          </Typography>
        )}

        {loading ? (
          <>
            <Skeleton
              variant="text"
              height={18}
              width="100%"
              style={{ marginBottom: "2px" }}
            />
            <Skeleton
              variant="text"
              height={18}
              width="90%"
              style={{ marginBottom: "2px" }}
            />
            <Skeleton
              variant="text"
              height={18}
              width="70%"
              style={{ marginBottom: "16px" }}
            />
          </>
        ) : (
          <Typography variant="subtitle2" className="mb-4" color="textPrimary">
            {product?.usage}
          </Typography>
        )}
        <Box className="d-flex">
          {loading ? (
            <>
              <Skeleton variant="text" height={20} width={250} />
            </>
          ) : (
            <Box
              className="d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <Typography variant="subtitle2" className="text-capitalize">
                {t("PRODUCTS_PAGE.HARDWARE_ENVIRONMENT")}:
              </Typography>
              <Typography variant="h2" className="text-capitalize">
                {product?.environment}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box className="side__info">
        <ResponsablePersonComponent
          user={product.responsible}
          loading={loading}
          editable={false}
          title={t("RESPONSIBLE_PERSON")}
        />
        <Box className="global__box__content p-3 mt-4 d-flex align-items-center justify-content-between">
          <Box>
            {loading ? (
              <Skeleton variant="text" height={20} width={80} />
            ) : (
              <Typography variant="subtitle2" color="textPrimary">
                {formatDate(product.createdAt, "DD.MM.YYYY")}
              </Typography>
            )}
            {loading ? (
              <Skeleton variant="text" height={20} width={70} />
            ) : (
              <Typography variant="body1" color="textSecondary">
                {t("CREATED")}
              </Typography>
            )}
          </Box>
          {loading ? (
            <Skeleton variant="text" height={20} width="60%" />
          ) : (
            <Typography
              variant="h2"
              color="textPrimary"
              className="text-capitalize"
            >
              {t(ProductStatus[product.status].name)}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ProductHeadComponent;
